import { Button, Header, Text } from '@wework/dieter-ui'
import React from 'react'
import { useSidebar } from '../../../hoc/withSidebar'
import Row from '../../Common/Row'
import { getRoomLinkeageStatus } from '../../SidebarBlocks/LinkRoom'

export default function DeskLinkeageHeader({ spaces, multiDeskSetter }) {
  const { openSideBar } = useSidebar()
  return (
    <Row>
      <div
        style={{
          flexDirection: 'row',
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <Button
          basic
          onClick={() => {
            multiDeskSetter(false)
            spaces.length > 1
              ? openSideBar('MultiSelect')
              : openSideBar('EditDrawer')
          }}
          icon="arrow left"
          style={{ marginRight: 12 }}
        />
        <Header as="h3" style={{ margin: 0 }}>
          Link desk inventory
        </Header>
      </div>

      {spaces.length < 2 && getRoomLinkeageStatus(spaces[0], true)}
    </Row>
  )
}
